import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_SUBSCRIPTION } from '@/modules/subscription/router';
import { subscriptionService } from '@/services/subscription';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export default function () {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        packageId: '',
        priceId: '',
        price: 0,
        maxReceivableTime: '',
        cycleChip: 0,
        timeUnit: 0,
        timeDuration: 0,
        totalLinked: null,
        startTime: new Date(),
        canDelete: false,
        canEdit: false
    });

    const fetch = crudAction.executeAction({
        request: () => subscriptionService.item.get(model.id),
        onSuccess: ({ data }) => {
            data.startTime = new Date(data.startTime);
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_SUBSCRIPTION.INDEX })
    });

    const remove = crudAction.confirmAndRemove({
        request: () => subscriptionService.item.remove(model.id),
        onSuccess: () => router.push({ name: ROUTE_NAME_SUBSCRIPTION.INDEX })
    });

    return { model, fetch, remove };
}
